<template>
  <div>
    <div
      class="hero"
      style="
        background: url('/images/foundationImage.png') lightgray center center /
          cover no-repeat;
      "
    >
      <div class="overlay">
        <div class="container">
          <div
            class="content d-flex flex-column align-items-center justify-content-center p-0"
          >
            <h1 class="text-center reveal-title">Foundation & Impact</h1>
            <p class="text-center paragraph-width reveal-description">
              Empowering education, healthcare, and community
              development—turning heritage into measurable, lasting impact.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="about" style="padding-block: 100px">
      <div class="container">
        <div
          class="row align-items-center"
          style="row-gap: 40px; overflow: hidden"
        >
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="d-flex flex-column gap-3">
              <p
                class="mb-0"
                style="color: #ddb657; font-size: 12px; font-weight: 700"
              >
                Foundation & Impact
              </p>
              <div class="sub-heading">
                <h3>Philanthropy & Social Impact</h3>
              </div>
              <p class="mb-0" style="font-size: 16px; color: #334155">
                Philanthropy has been integral to the Aljabiri family identity
                for generations. Long before the Group was formalized, the
                family supported education, healthcare, and community
                development across the Arab world and beyond.
              </p>
              <router-link
                to="/getTouch"
                class="text-white"
                style="
                  font-size: 14px;
                  padding: 8px 14px;
                  border-radius: 10px;
                  background-color: #ddb657;
                  width: fit-content;
                "
              >
                Contact with us
              </router-link>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="img mb-3" style="aspect-ratio: 2/1.3; overflow: hidden">
              <img
                src="/images/PhilanthropyImage.png"
                alt="aboutImage"
                class="w-100 h-100 rounded shadow-sm"
                style="object-fit: cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="historical-section">
      <div class="container">
        <div class="text-center mb-5">
          <h1 class="main-title text-center">Historical Contributions</h1>
          <p class="subtitle text-center">
            A tradition of service reflected in how resources were allocated and
            responsibilities carried out.
          </p>
        </div>

        <div class="timeline-container">
          <div
            v-for="(item, index) in contributions"
            :key="index"
            class="timeline-item"
          >
            <div class="timeline-marker"></div>
            <div class="timeline-content">
              <h3 class="period-title">{{ item.period }}</h3>
              <p class="period-description">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="apart about-sec default-padding"
      style="background-color: #f9fafb"
    >
      <div class="container">
        <div
          class="d-flex flex-column gap-5 justify-content-center align-items-center mb-4"
        >
          <div class="sub-heading d-flex flex-column align-items-center">
            <h3 class="text-center">Modern Commitment</h3>
            <p class="text-center" style="color: #475569">
              Today, the Group continues this tradition through a structured
              philanthropic approach.
            </p>
          </div>
        </div>
        <div class="d-flex flex-column gap-3">
          <div class="row g-4">
            <div
              v-for="(card, index) in cards"
              :key="index"
              class="col-md-4 d-flex"
            >
              <div
                class="service-card hover-lift d-flex flex-column gap-3 w-100 border-0"
                style="
                  border-color: #f5e9cd;
                  border-radius: 8px;
                  padding: 24px;
                  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.08);
                "
              >
                <div class="d-flex align-items-center gap-3">
                  <div v-html="card.icon"></div>
                  <h4 class="text-start mb-0">{{ card.title }}</h4>
                </div>
                <div class="card-content">
                  <p class="mb-0 text-start">{{ card.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="p-4 bg-white d-flex align-items-center justify-content-between"
          style="
            margin-top: 40px;
            border: 1px solid #e2e8f0;
            border-radius: 16px;
          "
        >
          <div class="d-flex flex-column gap-1">
            <p class="mb-0" style="color: #0f172a">Partnerships & Grants</p>
            <p class="mb-0" style="font-size: 14px; color: #475569">
              We welcome partnerships with investors, governments, and
              institutions worldwide to build sustainable growth and enduring
              relationships!
            </p>
          </div>
          <router-link
            to="/getTouch"
            class="text-white border-0"
            style="
              background-color: #ddb657;
              border-radius: 12px;
              padding: 16px 20px;
              font-size: 16px;
            "
          >
            Get in touch
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import ScrollReveal from 'scrollreveal';

onMounted(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  const sr = ScrollReveal({
    origin: 'bottom',
    distance: '60px',
    duration: 1500,
    delay: 200,
    reset: false
  });

  // Hero section animations
  sr.reveal('.hero .content h1', {
    origin: 'left',
    delay: 200,
    distance: '80px',
    duration: 1500
  });

  sr.reveal('.hero .content p', {
    delay: 600,
    distance: '40px'
  });

  // About section animations
  sr.reveal('.about .sub-heading', {
    origin: 'left',
    delay: 200
  });

  sr.reveal('.about p', {
    delay: 400,
    interval: 200
  });

  sr.reveal('.about img', {
    origin: 'right',
    delay: 600,
    distance: '80px'
  });

  // Historical section animations
  sr.reveal('.historical-section .text-center', {
    delay: 200
  });

  sr.reveal('.timeline-item', {
    delay: 400,
    interval: 200,
    distance: '40px',
    origin: 'left'
  });

  // Modern Commitment section animations
  sr.reveal('.apart .sub-heading', {
    delay: 200
  });

  sr.reveal('.service-card', {
    delay: 400,
    interval: 200,
    scale: 0.95
  });

  sr.reveal('.bg-white', {
    delay: 600,
    distance: '40px'
  });
});

const cards = [
  {
    title: "Education",
    text: "Scholarships, vocational training, and research collaborations with universities in Asia and the Middle East.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 21V7" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 12L18 14L22 10" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22 6V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7C12 5.93913 11.5786 4.92172 10.8284 4.17157C10.0783 3.42143 9.06087 3 8 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H9C9.79565 18 10.5587 18.3161 11.1213 18.8787C11.6839 19.4413 12 20.2044 12 21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17V15.7" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`,
  },
  {
    title: "Healthcare",
    text: "Partnerships with hospitals and support for emergency relief initiatives.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 14C20.49 12.54 22 10.79 22 8.5C22 7.04131 21.4205 5.64236 20.3891 4.61091C19.3576 3.57946 17.9587 3 16.5 3C14.74 3 13.5 3.5 12 5C10.5 3.5 9.26 3 7.5 3C6.04131 3 4.64236 3.57946 3.61091 4.61091C2.57946 5.64236 2 7.04131 2 8.5C2 10.8 3.5 12.55 5 14L12 21L19 14Z" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.21875 12H9.49875L9.99875 11L11.9987 15.5L13.9987 8.5L15.4987 12H20.7688" stroke="#DDB657" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`,
  },
  {
    title: "Community Development",
    text: "Funding for rural revitalization, sustainable housing, and cultural preservation projects.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2Z" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 22V18H15V22" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 6H8.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 6H16.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 6H12.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 10H12.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 14H12.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 10H16.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 14H16.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 10H8.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 14H8.01" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`,
  },
  {
    title: "Profitable Social Ventures",
    text: "Support for business ideas that combine profitability with positive community impact ensuring long-term sustainability.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 15H13C13.5304 15 14.0391 14.7893 14.4142 14.4142C14.7893 14.0391 15 13.5304 15 13C15 12.4696 14.7893 11.9609 14.4142 11.5858C14.0391 11.2107 13.5304 11 13 11H10C9.4 11 8.9 11.2 8.6 11.6L3 17" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 20.9998L8.6 19.5998C8.9 19.1998 9.4 18.9998 10 18.9998H14C15.1 18.9998 16.1 18.5998 16.8 17.7998L21.4 13.3998C21.7859 13.0351 22.0111 12.5321 22.0261 12.0014C22.0411 11.4706 21.8447 10.9557 21.48 10.5698C21.1153 10.1839 20.6123 9.95867 20.0816 9.94367C19.5508 9.92867 19.0359 10.1251 18.65 10.4898L14.45 14.3898" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 16L8 22" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.0001 11.9001C17.6017 11.9001 18.9001 10.6017 18.9001 9.0001C18.9001 7.39847 17.6017 6.1001 16.0001 6.1001C14.3985 6.1001 13.1001 7.39847 13.1001 9.0001C13.1001 10.6017 14.3985 11.9001 16.0001 11.9001Z" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 8C7.65685 8 9 6.65685 9 5C9 3.34315 7.65685 2 6 2C4.34315 2 3 3.34315 3 5C3 6.65685 4.34315 8 6 8Z" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`,
  },
  {
    title: "Faith & Heritage",
    text: "Support for historical culture and heritage initiatives, preserving traditions while building bridges across societies.",
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 22H21" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 18V11" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 18V11" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 18V11" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 18V11" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 2L20 7H4L12 2Z" stroke="#DDB657" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`,
  },
];

const contributions = ref([
  {
    period: "Early 20th Century",
    description:
      "Establishment of night schools and resting places in available venues, serving workers, travelers, and the underserved.",
  },
  {
    period: "World War II Era",
    description:
      "Conversion of family facilities into refugee aid centers, offering shelter, food, and relief during conflict.",
  },
  {
    period: "Mid to Late 20th Century",
    description:
      "Scholarships, hospitals, and direct community support extended across the Middle East, pairing development with social responsibility.",
  },
]);
</script>

<style scoped>
.paragraph-width {
  width: 80%;
  line-height: 150%;
}
@media (max-width: 700px) {
  .paragraph-width {
    width: 100%;
  }
}
.text-box {
  bottom: -20px;
  right: 20px;
  padding: 16px 20px;
}
.hero {
  aspect-ratio: 3 / 0.8;
  width: 100%;
  min-height: 400px;
}

.content {
  width: 100%;
  text-align: center;
  margin: auto;
}
.paragraph-width {
  width: 55%;
}
@media (max-width: 700px) {
  .paragraph-width {
    width: 100%;
  }
}
.historical-section {
  padding: 60px 0;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.05rem;
  color: #6c757d;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

.timeline-container {
  max-width: 900px;
  margin: 3rem auto;
  position: relative;
  padding-left: 60px;
}

.timeline-container::before {
  content: "";
  position: absolute;
  left: 14px;
  top: 20px;
  bottom: 20px;
  width: 2px;
  background-color: #ddb657;
}

.timeline-item {
  position: relative;
  margin-bottom: 3rem;
  display: flex;
  align-items: flex-start;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: -44px;
  top: 50%;
  transform: translate(-50%);
  width: 16px;
  height: 16px;
  background-color: #ddb657;
  border-radius: 50%;
  box-shadow: 0 0 0 4px #f8f9fa;
  z-index: 2;
}

.timeline-content {
  flex: 1;
  background: white;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.timeline-content:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.period-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 0.75rem;
}

.period-description {
  font-size: 12px;
  color: #334155;
  line-height: 1.7;
  margin: 0;
}

@media (max-width: 768px) {
  .main-title {
    font-size: 1.8rem;
  }

  .subtitle {
    font-size: 0.95rem;
    padding: 0 1rem;
  }

  .timeline-container {
    padding-left: 40px;
  }

  .timeline-container::before {
    left: 10px;
  }

  .timeline-marker {
    left: -30px;
    width: 12px;
    height: 12px;
  }

  .period-title {
    font-size: 1.1rem;
  }

  .period-description {
    font-size: 0.9rem;
  }
}

/* Animation styles */
.reveal-title,
.reveal-description,
.timeline-item,
.service-card {
  visibility: hidden;
}

.timeline-content {
  transform: translateX(0);
  transition: all 0.5s ease;
}

.service-card {
  transition: all 0.3s ease-out;
}

.service-card:hover {
  transform: translateY(-5px);
}
</style>
